module.exports = __webpack_public_path__ + "media/images/logo-ab9e962024d38177beb28eeb7960832e.png";